import { call, put, select, takeLatest } from 'redux-saga/effects';
import { delay } from 'redux-saga'

import {
    GET_MOVIE_THEATERS,
    ADD_CINEMA_ON_FAVORITE,
    REMOVE_CINEMA_FROM_FAVORITE,
    GET_HALL_CONFIGURATION,
    STORE_SELECTED_SEATS,
    CLEAR_HALL_CONFIGURATION,
    ADD_MOVIETHEATER_TO_FAVORITE,
    REMOVE_MOVIETHEATER_FROM_FAVORITE,
    GET_MOVIE_THEATERS_WITH_TICKETS,
    GET_MOVIE_THEATERS_WITH_TICKETS_SEE_MORE,
    GET_MOVIE_THEATERS_SEE_MORE,
    STORE_SELECTED_COUCH,
    STORE_SELECTED_TICKETS,
    REMOVE_SELECTED_TICKETS,
    CLEAR_SELECTED_SEATS_AND_COUCH
} from "../actions/types";
import { showGeneralError, hideGeneralError } from '../actions/general.actions';
import { GENERIC_ERROR_MESSAGE } from "../config/messages";
import { getMovieTheaters, addCinemaOnFavorite, removeCinemaOnFavorite, getHallConfig, getMovieTheatersWithTickets } from "../api/movietheaters.api";
import { requestMoviesByCinemaIdSuccess } from "../actions/schedule.actions";
import {
    getMovieTheatersSucceeded,
    addCinemaOnFavouriteSucceeded,
    removeCinemaOnFavouriteSucceeded,
    getHallConfigurationSucceeded,
    storeSelectedSeatsSucceeded,
    clearHallConfigurationSucceeded,
    getMovieTheatersWithTicketsSucceeded,
    getMovieTheatersSeeMoreSucceeded,
    storeSelectedCouchSucceeded,
    storeSelectedTicketsSucceeded,
    removeSelectedTicketsSucceeded,
    getMovieTheatersWithTicketsSeeMoreSucceeded
} from "../actions/movietheaters.actions";
import { showSpinner, hideSpinner } from '../actions/loading.actions';
import { storeSelectedHourSucceeded } from '../actions/filters.actions';
import { push } from 'react-router-redux';
import { MOVIE_THEATERS_ROUTE } from '../config/routes';
import { slugify } from '../helpers/general.helper';


function* getMovieTheatersSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getMovieTheaters, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        let paginatedData = response.data;
        if (response.status === 200) {
            yield put(getMovieTheatersSucceeded({ paginatedData: paginatedData }));
        }


    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getMovieTheatersSeeMoreSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getMovieTheaters, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 200) {
            const prevState = yield select(state => state.movieTheaters.paginatedData);
            if (prevState.rows) {
                const movieTheaters = { ...prevState, rows: prevState.rows.concat(response.data.rows), pager: response.data.pager }
                yield put(getMovieTheatersSeeMoreSucceeded({ paginatedData: movieTheaters }));
            }
        }

    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* addCinemaOnFavouriteSaga(action) {
    try {
        let cinemaUuId = action.payload.uuId;
        yield put(showSpinner());
        const response = yield call(addCinemaOnFavorite, action.payload);

        if (response.status) {
            yield put(hideSpinner());
        }

        if (response.status === 201) {
            const prevState = yield select(state => state.schedule.scheduleAllMovies);

            prevState.forEach(item => {
                item.schedule.forEach(schedule => {
                    if (schedule.cinema.cinema_uuid === cinemaUuId) {
                        schedule.cinema.favorite.push(response.data.data.id);
                    }
                });
            });

            yield put(requestMoviesByCinemaIdSuccess({ scheduleAllMovies: prevState }));
        }

        if (response.statusText === "OK") {
            yield put(addCinemaOnFavouriteSucceeded({ success: true }));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* removeCinemaOnFavouriteSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(removeCinemaOnFavorite, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.statusText === "OK") {
            yield put(removeCinemaOnFavouriteSucceeded({ success: true }));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getHallConfigurationSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getHallConfig, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }
        if (response.status === 200) {
            yield put(getHallConfigurationSucceeded(response.data));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* storeSelectedSeatsSaga(action) {
    try {
        if (action.payload.length > 0) {
            const prevState = yield select(state => state.movieTheaters.selectedSeats);
            const selectedSeat = [...prevState];
            action.payload.map(seat => {
                if (!selectedSeat.find(elem => elem.id_seat === seat.id_seat)) {
                    selectedSeat.push(seat);
                }
                else {
                    let index = selectedSeat.findIndex(elem => elem.id_seat === seat.id_seat);
                    selectedSeat.splice(index, 1);
                }
            });
            yield put(storeSelectedSeatsSucceeded(selectedSeat));
        }
    } catch (e) {
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* storeSelectedCouchSaga(action) {
    try {
        if (action.payload.length > 0) {
            const prevState = yield select(state => state.movieTheaters.selectedCouch);
            const selectedCouch = [...prevState];
            action.payload.map(seat => {
                if (!selectedCouch.find(elem => elem.id_seat === seat.id_seat)) {
                    selectedCouch.push(seat);
                }
                else {
                    let index = selectedCouch.findIndex(elem => elem.id_seat === seat.id_seat);
                    selectedCouch.splice(index, 1);
                }
            });
            yield put(storeSelectedCouchSucceeded(selectedCouch));
        }
    } catch (e) {
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* clearSelectedSeatsAndCouchSaga(action) {
    try {
        yield put(storeSelectedSeatsSucceeded([]));
        yield put(storeSelectedCouchSucceeded([]));
    } catch (e) {
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* clearHallConfigurationSaga(action) {
    try {
        yield put(clearHallConfigurationSucceeded());
        yield put(storeSelectedHourSucceeded({}));
    } catch (e) {
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* addMovieTheaterToFavoriteSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(addCinemaOnFavorite, action.payload);

        if (response.status) {
            yield put(hideSpinner());
        }

        if (response.status === 201) {
            const prevState = yield select(state => state.movieTheaters.paginatedData);
            let index = prevState.rows.findIndex(element => element.cinema_uuid === action.payload);
            prevState.rows[index].favorite.push({ uuid: response.data.data.id });
            const addCinemaToFav = [...prevState];
            yield put(getMovieTheatersSucceeded(addCinemaToFav));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* removeMovieTheaterFromFavoriteSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(removeCinemaOnFavorite, action.payload);

        if (response.status) {
            yield put(hideSpinner());
        }

        if (response.status === 204) {
            const prevState = yield select(state => state.movieTheaters.paginatedData);
            let index = prevState.rows.findIndex(element => element.cinema_uuid === action.payload.cinema_uuid);
            prevState.rows[index].favorite = [];
            const removeCinemaFromFav = [...prevState];
            yield put(getMovieTheatersSucceeded(removeCinemaFromFav));
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getMovieTheatersWithTicketsSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getMovieTheatersWithTickets, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }

        let paginatedData = response.data;
        if (paginatedData.rows.length === 0) {
            const selectedLocation = yield select(state => state.filters.selectedCinemaLocation);
            yield put(push(MOVIE_THEATERS_ROUTE.replace(':slug', slugify(selectedLocation))));
        } else {
            if (response.status === 200) {
                yield put(getMovieTheatersWithTicketsSucceeded({ paginatedData: paginatedData }));
            }
        }
    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* getMovieTheatersWithTicketsSeeMoreSaga(action) {
    try {
        yield put(showSpinner());
        const response = yield call(getMovieTheatersWithTickets, action.payload);
        if (response.status) {
            yield put(hideSpinner());
        }

        if (response.status === 200) {
            const prevState = yield select(state => state.movieTheaters.movieTheatersTickets.paginatedData);
            if (prevState.rows) {
                const movieTheaters = { ...prevState, rows: prevState.rows.concat(response.data.rows), pager: response.data.pager }
                yield put(getMovieTheatersWithTicketsSeeMoreSucceeded({ paginatedData: movieTheaters }));
            }
        }

    } catch (e) {
        yield put(hideSpinner());
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* storeSelectedTicketsSaga(action) {
    try {
        yield put(storeSelectedTicketsSucceeded(action.payload));
    } catch (e) {
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}

function* removeSelectedTicketsSaga(action) {
    try {
        yield put(removeSelectedTicketsSucceeded(action.payload));
    } catch (e) {
        yield put(showGeneralError(GENERIC_ERROR_MESSAGE));
        yield call(delay, 5000);
        yield put(hideGeneralError(''));
    }
}


export default function* moviesSaga() {
    yield takeLatest(GET_MOVIE_THEATERS, getMovieTheatersSaga);
    yield takeLatest(GET_MOVIE_THEATERS_SEE_MORE, getMovieTheatersSeeMoreSaga);
    // yield takeLatest(ADD_CINEMA_ON_FAVORITE, addCinemaOnFavouriteSaga);
    // yield takeLatest(REMOVE_CINEMA_FROM_FAVORITE, removeCinemaOnFavouriteSaga);
    yield takeLatest(GET_HALL_CONFIGURATION, getHallConfigurationSaga);
    yield takeLatest(STORE_SELECTED_SEATS, storeSelectedSeatsSaga);
    yield takeLatest(STORE_SELECTED_COUCH, storeSelectedCouchSaga);
    yield takeLatest(CLEAR_SELECTED_SEATS_AND_COUCH, clearSelectedSeatsAndCouchSaga);
    yield takeLatest(CLEAR_HALL_CONFIGURATION, clearHallConfigurationSaga);
    yield takeLatest(ADD_MOVIETHEATER_TO_FAVORITE, addMovieTheaterToFavoriteSaga);
    yield takeLatest(REMOVE_MOVIETHEATER_FROM_FAVORITE, removeMovieTheaterFromFavoriteSaga);
    yield takeLatest(GET_MOVIE_THEATERS_WITH_TICKETS, getMovieTheatersWithTicketsSaga);
    yield takeLatest(GET_MOVIE_THEATERS_WITH_TICKETS_SEE_MORE, getMovieTheatersWithTicketsSeeMoreSaga);
    yield takeLatest(STORE_SELECTED_TICKETS, storeSelectedTicketsSaga);
    yield takeLatest(REMOVE_SELECTED_TICKETS, removeSelectedTicketsSaga);
}



// WEBPACK FOOTER //
// ./src/SHARED/sagas/movietheaters.saga.js